/* eslint-disable */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import {
  IAPIListRequestOptions,
  IAPIListResponse,
  IBrowseLinkApiResponse,
} from '@sondermind/utilities/models-http';

@Injectable({
  providedIn: 'root',
})
export class BrowseStateHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService,
  ) {}

  getBrowseLinks(options: Partial<IAPIListRequestOptions> = {}): Observable<IAPIListResponse<IBrowseLinkApiResponse>> {
    const params = this.http.generateListParams(options);
    return this.http
      .get<IAPIListResponse<IBrowseLinkApiResponse>>(this.stateIndexUrl, params)
      .pipe(this.http.handleHttpErrorStrict());
  }

  getBrowseCityLinks(options: Partial<IAPIListRequestOptions> = {}): Observable<IAPIListResponse<IBrowseLinkApiResponse>> {
    const params = this.http.generateListParams(options);
    return this.http
      .get<IAPIListResponse<IBrowseLinkApiResponse>>(this.cityIndexUrl, params)
      .pipe(this.http.handleHttpErrorStrict());
  }

  get baseUrl(): string {
    return `${this.configurationService.env.svcBase}/provider_profiles/provider_directory`;
  }

  get stateIndexUrl(): string {
    return `${this.baseUrl}/browse_links`;
  }

  get cityIndexUrl(): string {
    return `${this.baseUrl}/browse_city_links`;
  }
}
